import type { Router, RouteLocationRaw } from 'vue-router';

/** Office-session changes reuse the router's protected-route login redirect. */
export async function handleAuthNavigation(
  router: Pick<Router, 'currentRoute' | 'replace'>,
  isAuthed: boolean,
  resolveHome: () => Promise<RouteLocationRaw>
) {
  const currentRoute = router.currentRoute.value;
  if (currentRoute.meta?.terminal === true) return;
  if (isAuthed && (currentRoute.meta?.public || currentRoute.name === 'login' || currentRoute.name === 'login-qr')) {
    const redirect = typeof currentRoute.query.redirect === 'string' ? currentRoute.query.redirect : '';
    const localRedirect = redirect.startsWith('/') && !redirect.startsWith('//');
    await router.replace(localRedirect ? redirect : await resolveHome());
    return;
  }
  if (!isAuthed && currentRoute.meta?.public !== true) {
    await router.replace({ name: 'login', query: { redirect: currentRoute.fullPath } });
  }
}
